import { injectable } from 'tsyringe'
import { OtherContentApiRepository } from '@/app/repositories/api/OtherContentApiRepository'
import { OtherContent } from '@/domain/entities/OtherContent'
import { EditOtherContentInterface } from '@/data/payload/contracts/OtherContentRequest'
@injectable()
export class OtherContentPresenter {
  private repository: OtherContentApiRepository

  constructor(repository: OtherContentApiRepository) {
    this.repository = repository
  }

  public loadOtherContent(params: Object, name: string): Promise<OtherContent> {
    return this.repository.getAll(params, name)
  }

  public editOtherContent(
    payload: EditOtherContentInterface
  ): Promise<OtherContent> {
    return this.repository.update(payload)
  }
}
